import Organization from '../models/organization/organization.model';

export namespace OrganizationActions {
  export class GetOrganization {
    static readonly type = '[Organization] Get Organization';

    constructor(public handle: string) {
    }
  }

  export class UpdateOrganization {
    static readonly type = '[Organization] Update Organization';

    constructor(public id: string, public organization: Organization) {
    }
  }
}
